import * as React from "react";
import classnames from "classnames";

const styles = require("./styles.module.scss");

interface SpinnerProps {
  active: boolean;
}

const Spinner: React.FunctionComponent<SpinnerProps> = ({ active }) => (
  <div className={classnames(styles.spinner, active && styles.active)} />
);

export default Spinner;
